export default class Share {
    static getApplicationName() {
        return { message: '', appName: '' };
    }

    static isPackageInstalled() {
        return { message: '', isInstalled: false };
    }
}
